import React from "react";
import Popper from "@mui/material/Popper";
import Grow from "@mui/material/Grow";
import Paper from "@mui/material/Paper";
import ClickAwayListener from "@mui/material/ClickAwayListener";
import MenuList from "@mui/material/MenuList";
import {PopperPlacementType} from "@mui/material";
import "./popperMenu.scss";
import {Utils} from "../../../../helpers/utils";

interface PopperMenuProps {
    isOpen: boolean;
    setOpen: (isOpen: boolean) => void;
    anchorEl: HTMLElement | null;
    placement?: PopperPlacementType | "bottom";
    doNotCloseAt?: string;
    children?: React.ReactNode;
    testId: string;
    className?: string;
}

export default function PopperMenu(props: PopperMenuProps): JSX.Element {
    const handleClose = (event: any) => {
        const node = event.target?.nodeName;
        let className = event?.target?.className;

        if (!props.doNotCloseAt || !className || !node) {
            props.setOpen(false);
            return;
        }

        // for mui ExpandMoreIcon svg
        if (className["animVal"]!==undefined) {
            className = className.animVal;
        }

        if (!className.includes(props.doNotCloseAt)) {
            props.setOpen(false);
        }
    };

    return (
        <Popper
            open={props.isOpen}
            anchorEl={props.anchorEl}
            placement={props.placement}
            transition
            className={`popper-menu ${props.className ? props.className : ""} ${Utils.isTabletOrMobile() ? "mobile" : ""}`}
        >
            {({TransitionProps, placement}) => (
                <Grow
                    {...TransitionProps}
                    style={{
                        transformOrigin:
                            placement === "bottom-start" ? "left top" : "left bottom",
                    }}
                >
                    <Paper data-testid={props.testId}>
                        <ClickAwayListener onClickAway={handleClose}>
                            <MenuList
                                autoFocusItem={props.isOpen}
                            >
                                {props.children}
                            </MenuList>
                        </ClickAwayListener>
                    </Paper>
                </Grow>
            )}
        </Popper>
    );
}
